import {Component} from '@angular/core';
import { ObjectDetailSubjectsComponent } from '../../../document-shared/components/object-detail-subjects/object-detail-subjects.component';

@Component({
  selector: 'icz-document-detail-subjects',
  templateUrl: './document-detail-subjects.component.html',
  styleUrls: ['./document-detail-subjects.component.scss'],
  imports: [ObjectDetailSubjectsComponent]
})
export class DocumentDetailSubjectsComponent {

}
